import React from 'react';
import { useGetWarehouseColumnsQuery } from 'data/__generated__';
import { TotemSelect, TotemSelectProps } from 'components/TotemSelect';

export function WarehouseColumnSelect({
    value,
    onChange,
    label = 'Entrepôt',
    placeholder = 'Sélectionner un entrepôt',
    dataTest,
    ...props
}: Omit<Extract<TotemSelectProps<string>, { isMulti?: false }>, 'value' | 'onChange' | 'options'> & {
    value: string | null;
    onChange: (columnId: string | null) => void;
    label?: string;
    placeholder?: string;
    dataTest?: string;
}) {
    const { data: warehouseColumnsData, loading } = useGetWarehouseColumnsQuery();

    const options = React.useMemo(
        () =>
            (warehouseColumnsData?.warehouseColumns || []).map((column) => ({
                label: `${column.site.name} - ${column.name}`,
                value: column._id,
            })),
        [warehouseColumnsData],
    );

    return (
        <TotemSelect
            dataTest={dataTest}
            label={label}
            placeholder={placeholder}
            value={value}
            options={options}
            onChange={onChange}
            isClearable
            disabled={loading}
            {...props}
        />
    );
}
